export enum AlarmLevel {
  LOWEST = 'LOWEST',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  HIGHEST = 'HIGHEST',
}

export enum RuleStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}

export enum MonitorObjectType {
  PV = 'PV',
  LOAD = 'LOAD',
  THERMAL = 'THERMAL',
  STORAGE = 'STORAGE',
}

export interface DispatchDeviationAlarmRule {
  id: number;
  code: string;
  name: string;
  monitorObjectType: MonitorObjectType;
  monitorObject: string;
  alarmLevel: AlarmLevel;
  status: RuleStatus;
  lastOperator: string;
  lastOperationTime: string;
  monitorObjectIds?: string[];
  dispatchPoint?: string;
  feedbackPoint?: string;
  monitoringDuration?: number;
  deviationRate?: number;
}

export interface RuleFilters {
  keyword?: string;
  alarmLevel?: AlarmLevel;
  monitorObjectType?: MonitorObjectType;
  monitorObject?: string;
  status?: RuleStatus;
}

export interface CreateRuleFormValues {
  name: string;
  monitorObjectType: MonitorObjectType;
  monitorObjectIds: string[];
  dispatchPoint: string;
  feedbackPoint: string;
  alarmLevel: AlarmLevel;
  monitoringDuration: number;
  deviationRate: number;
}
